import { useCallback } from "react";
import {
  useGenerateDexPresignedPostMutation,
  useProcessDexDocumentMutation,
} from "#graphql/supergraphHooks";

export interface UseUploadDocumentResult {
  uploadDocument: (file: File) => Promise<void>;
}

export function useUploadDocument(): UseUploadDocumentResult {
  const [getPresignedPost] = useGenerateDexPresignedPostMutation();
  const [processDexDocument] = useProcessDexDocumentMutation();

  const uploadDocument = useCallback(
    async (file: File) => {
      const { data } = await getPresignedPost({
        variables: { filename: file.name },
      });
      const post = data?.generateDexPresignedPost;
      if (!post) throw new Error("Failed to generate a presigned POST");

      // S3 presigned POST: all signed fields first, file field LAST.
      const form = new FormData();
      for (const [k, v] of Object.entries(post.fields as Record<string, string>)) {
        form.append(k, v);
      }
      form.append("file", file);

      const res = await fetch(post.url, { method: "POST", body: form });
      if (!res.ok) throw new Error(`S3 upload failed: ${res.status}`);

      await processDexDocument({
        variables: {
          documentId: post.documentId,
          s3PdfKey: post.s3PdfKey,
          originalFilename: file.name,
        },
      });
    },
    [getPresignedPost, processDexDocument],
  );

  return { uploadDocument };
}
